var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m27.736 26.507-6.802-6.786a11.84 11.84 0 0 0 2.932-7.806c0-6.569-5.352-11.9-11.93-11.9C5.353.015 0 5.354 0 11.915c0 6.56 5.352 11.9 11.93 11.9 2.993 0 5.723-1.1 7.825-2.925l6.802 6.785c.163.162.38.248.59.248a.81.81 0 0 0 .59-.248.82.82 0 0 0 0-1.168M1.668 11.915c0-5.648 4.607-10.228 10.253-10.228 5.662 0 10.254 4.595 10.254 10.228 0 5.632-4.6 10.236-10.254 10.236-5.646 0-10.253-4.588-10.253-10.236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "search_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
};
export default SvgSearch;